export default __webpack_public_path__ + "static/media/Incidents-1.816fa643.png";